import React from 'react';
import { reportClientError } from '../lib/clientErrorReporter';

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Старая вкладка ссылается на JS-чанк, которого уже нет на сервере после нового
    // деплоя (хэш поменялся). Лечится обычной перезагрузкой — пробуем один раз молча,
    // без карточки в error-watch; если и после reload не помогло — реальная проблема.
    const isChunkError =
      error.name === 'ChunkLoadError' ||
      /Loading (chunk|CSS chunk) .+ failed/i.test(error.message || '');
    if (isChunkError) {
      const key = 'chunk-reload-once';
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        window.location.reload();
        return;
      }
      sessionStorage.removeItem(key);
    }
    console.error('ErrorBoundary caught:', error, info);
    reportClientError(error, {}); // в бэкенд-ловец (карточка source=frontend/exe)
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, color: '#b91c1c' }}>
          <h2>Что-то пошло не так</h2>
          <p>Произошла ошибка на странице. Попробуй обновить (Ctrl+F5) или вернуться назад.</p>
          {this.state.error && (
            <details>
              <summary>Технические детали</summary>
              <pre>{String(this.state.error?.message || this.state.error)}</pre>
            </details>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
